export const iconFontAwesomeMapsRecycle = (
	<i className="fa-solid fa-recycle"></i>
);
